export default __webpack_public_path__ + "static/media/tfg-title-en.bf306074.webp";